export default __webpack_public_path__ + "ab557eea2a92972b5ecd2ae8cec24511.png";